import { store, itiHttpService, itiMessageService, itiSignalRService, ItiString } from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { CollaborativeArea } from '@/shared/dtos/collaborative-area';
import { CollaborativeAreaType } from '@/shared/dtos/collaborative-area-type';
import { CollaborativeAreaMember } from '@/shared/dtos/collaborative-area-member';
import { Rol } from '@/shared/dtos/rol';

@Module({
    namespaced: true,
    name: 'CollaborativeAreaModule',
    store,
    dynamic: true,
})
class CollaborativeAreaModule extends VuexModule {

    public collaborativeAreasInfo: CollaborativeArea[] = [];
    public nameUsersByCollaborativeAreas: CollaborativeArea[] = [];
    public selectedCollaborativeArea: CollaborativeArea = new CollaborativeArea();
    public collaborativeAreaTypes: CollaborativeAreaType[] = [];
    public usersAndRolesArea: CollaborativeAreaMember[] = [];
    public collaborativeAreaMember: CollaborativeAreaMember = new CollaborativeAreaMember();
    public myId: number = 0;
    public areaEditMode: boolean = false;

    @Mutation
    public newCollaborativeArea() {
        this.selectedCollaborativeArea = new CollaborativeArea();
        this.selectedCollaborativeArea.users = [];
    }

    @Action
    public async saveCollaborativeArea(collaborativeArea: CollaborativeArea) {
        let res = null;
        if (collaborativeArea.id == null) {
            collaborativeArea.id = 0;
            collaborativeArea.active = true;
            res = await itiHttpService.post(API.collaborativeArea + "/Create_CollaborativeArea", collaborativeArea.toJson());
        } else {
            const collaborativeAreaDB: CollaborativeArea = new CollaborativeArea(collaborativeArea);
            res = await itiHttpService.put(API.collaborativeArea + "/Put", collaborativeAreaDB.toJson());
        }
        this.context.commit('setCollaborativeAreaById', res);
    }

    @Action
    public async asociateUserToCollaborativeArea() {
        await itiHttpService.post(API.collaborativeArea + "/AsociateUserToCollaborativeArea?userId=" + this.collaborativeAreaMember.userId + "&collaborativeAreaId=" + this.collaborativeAreaMember.ambitId + "&roleId=" + this.collaborativeAreaMember.roleId, "");
    }

    @Action
    public async disassociateUserToCollaborativeArea() {
        await itiHttpService.post(API.collaborativeArea + "/DisassociateUserToCollaborativeArea?userId=" + this.collaborativeAreaMember.userId + "&collaborativeAreaId=" + this.collaborativeAreaMember.ambitId, "");
    }

    @Action
    public async changeStateCollaborativeArea(state: boolean) {
        this.selectedCollaborativeArea.active = state;
        await itiHttpService.post(API.collaborativeArea + "/ChangeStateCollaborativeArea", this.selectedCollaborativeArea);
    }

    @Mutation
    public setMyId(myId: number) {
        this.myId = myId;
    }

    @Action
    public async fetchId() {
        await itiHttpService.get(API.chat + '/id', null, false)
            .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
            .then((value) => this.context.commit('setMyId', Number.parseInt(value)));
    }

    @Mutation
    public setCollaborativeAreaById(collaborativeArea: CollaborativeArea) {
        this.selectedCollaborativeArea = collaborativeArea;
    }

    @Action
    public async getCollaborativeAreaById(ambitId: number) {
        const res = await itiHttpService.get(API.collaborativeArea + '/(' + ambitId + ')');
        this.context.commit('setCollaborativeAreaById', res);
    }

    @Mutation
    public setCollaborativeAreasInfo(collaborativeAreasInfo: CollaborativeArea[]) {
        this.collaborativeAreasInfo = collaborativeAreasInfo;
    }

    @Action
    public async getCollaborativeAreasInfo() {
        const res = await itiHttpService.get(API.collaborativeArea + '/GetCollaborativeAreasInfo');
        this.context.commit('setCollaborativeAreasInfo', res);
    }

    @Action
    public async getActiveCollaborativeAreasInfoByType(type: number) {
        const res = await itiHttpService.get(API.collaborativeArea + '/GetActiveCollaborativeAreasInfoByType?typeId=' + type);
        this.context.commit('setCollaborativeAreasInfo', res);
    }

    @Action
    public async getInactiveCollaborativeAreasInfoByType(type: number) {
        const res = await itiHttpService.get(API.collaborativeArea + '/GetInactiveCollaborativeAreasInfoByType?typeId=' + type);
        this.context.commit('setCollaborativeAreasInfo', res);
    }

    @Mutation
    public setNameUsersByCollaborativesAreas(nameUsersByCollaborativeAreas: CollaborativeArea[]) {
        this.nameUsersByCollaborativeAreas = nameUsersByCollaborativeAreas;
    }

    @Action
    public async getNameUsersByCollaborativesAreas() {
        const res = await itiHttpService.get(API.collaborativeArea + '/GetNameUsersByCollaborativeAreas');
        this.context.commit('setNameUsersByCollaborativesAreas', res);
    }

    @Mutation
    public setCollaborativeAreaTypes() {
        this.collaborativeAreaTypes = [];
        this.collaborativeAreaTypes[0] = new CollaborativeAreaType(0, "PublicArea");
        this.collaborativeAreaTypes[1] = new CollaborativeAreaType(1, "WorkGroups");
        //this.collaborativeAreaTypes[2] = new CollaborativeAreaType(2, "PrivateArea");        
    }

    @Mutation
    public setUsersAndRolesByAmbitId(usersAndRoles: CollaborativeAreaMember[]) {
        this.usersAndRolesArea = usersAndRoles;
    }

    @Action
    public async getUsersAndRolesByAmbitId(ambitId: number) {
        const res = await itiHttpService.get(API.collaborativeArea + '/GetUsersAndRolesByAmbitId?ambitId=' + ambitId);
        this.context.commit('setUsersAndRolesByAmbitId', res);
    }

    // @Action
    // public async getUsersAndRolesByAmbitIdExceptPublicArea(ambitId: number) {        
    //     const res = await itiHttpService.get(API.collaborativeArea + '/GetUsersAndRolesByAmbitIdExceptPublicArea?ambitId=' + ambitId);
    //     this.context.commit('setUsersAndRolesByAmbitId', res);
    // }

    @Mutation
    public setAreaEditMode(editar: boolean) {
        this.areaEditMode = editar;
    }

    @Mutation
    public setNewCollaborativeAreaMember() {
        this.collaborativeAreaMember = new CollaborativeAreaMember();
    }

}
export default getModule(CollaborativeAreaModule);
